module.exports = __webpack_public_path__ + "dashboard/img/plus.b411c83d972b02a3ca3460e147b70f15.svg";